import { render, staticRenderFns } from "./web_hook.vue?vue&type=template&id=1dfbe5a4&scoped=true"
import script from "./web_hook.vue?vue&type=script&lang=js"
export * from "./web_hook.vue?vue&type=script&lang=js"
import style0 from "./web_hook.vue?vue&type=style&index=0&id=1dfbe5a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfbe5a4",
  null
  
)

export default component.exports